import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createBlock(_component_a_result, {
    class: "box_result",
    status: "success",
    title: _ctx.$Enum.TextEnum.SuccessLogin,
    "sub-title": "正在返回..."
  }, null, 8 /* PROPS */, ["title"]))
}